module.exports = __webpack_public_path__ + "img/mountain_meal.8d46345c.jpg";